import React from 'react';
import { Box } from '@mui/material';
import { useLocation, useParams } from 'react-router-dom';
import LiveScoreboard from '../components/LiveScoreboard';

const Scores = () => {
  const location = useLocation();
  const { gamePk: paramGamePk } = useParams();
  // Accept gamePk from URL param (/scores/822971) or navigation state
  const gamePk = paramGamePk || location.state?.gamePk || null;

  return (
    <Box sx={{ p: { xs: 1, sm: 2 }, width: '100%', boxSizing: 'border-box', overflowX: 'hidden' }}>
      <LiveScoreboard initialGamePk={gamePk} />
    </Box>
  );
};

export default Scores;
